import React from "react";

const PasswordCriteriaItem = ({ isValid }:any) => {
  return (
    <div className="flex items-center gap-2">
      <div
        className={`w-[140px] h-1 rounded-full ${
          isValid ? "bg-[#22C55E]" : "bg-[#9D9898]"
        }`}
      >
        {/* Removed the checkmark SVG since it doesn't make sense for a thin bar */}
      </div>
    </div>
  );
};

const PasswordCriteria = ({ password }:any) => {
  // Make sure we're handling the case where password might be undefined
  const passwordValue = password || "";
  
  const criteria = [
    { key: "uppercase", isValid: /[A-Z]/.test(passwordValue) },
    { key: "specialChar", isValid: /[!@#$%^&*]/.test(passwordValue) },
    { key: "number", isValid: /\d/.test(passwordValue) },
    { key: "length", isValid: passwordValue.length >= 8 },
  ];

  return (
    <div className="w-full -mt-2">
      <div className="pl-1 rounded-md grid grid-cols-4 gap-3">
        {criteria.map((item) => (
          <PasswordCriteriaItem key={item.key} isValid={item.isValid} />
        ))}
      </div>
      <p className="text-sm text-[#4E4E4E] font-medium mt-2">
        Your password must contain at least 8 characters, one uppercase letter,
        one special character, and one number
      </p>
    </div>
  );
};

export default PasswordCriteria;